'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes$PUBLISH_;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _strings = require('conversations-core/constants/strings');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _OutgoingMessageActions = require('conversations-core/actions/OutgoingMessageActions');

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPubNubAction = (0, _getIn2.default)(['meta', _strings.PUBNUB_KEY]);

exports.default = (_ActionTypes$PUBLISH_ = {}, _defineProperty(_ActionTypes$PUBLISH_, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE, function (action, getState, dispatch, client) {
  var pubNubAction = getPubNubAction(action);
  var channel = pubNubAction.channel,
      message = pubNubAction.message;


  var publishData = {
    message: (0, _PubNubMessageSerializer.serialize)(message),
    channel: channel
  };

  client.publish(publishData, function (status) {
    if (!status.error) {
      // PUBLISH_OUTGOING_MESSAGE_SUCCESS will be dispatched when the message
      // is broadcast over the channel.
      return;
    }

    dispatch((0, _OutgoingMessageActions.publishOutgoingMessageFailure)({ message: message, channel: channel, status: status }));
  });
}), _defineProperty(_ActionTypes$PUBLISH_, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_SUCCESS, function (action, getState, dispatch) {
  var _getPubNubAction = getPubNubAction(action),
      channel = _getPubNubAction.channel,
      message = _getPubNubAction.message;

  dispatch((0, _ConversationsActions.updateMessageInConversation)({
    updated: (0, _PubNubMessageFactory.buildPublishedMessage)(message),
    channel: channel,
    message: message
  }));
}), _defineProperty(_ActionTypes$PUBLISH_, _ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_FAILURE, function (action, getState, dispatch) {
  var _getPubNubAction2 = getPubNubAction(action),
      channel = _getPubNubAction2.channel,
      message = _getPubNubAction2.message,
      status = _getPubNubAction2.status;

  var updated = (0, _PubNubMessageFactory.buildPublishFailedMessage)(message);

  dispatch((0, _ConversationsActions.updateMessageInConversation)({ updated: updated, channel: channel, message: message }));

  window.Raven.captureMessage('PUBLISH_OUTGOING_MESSAGE_FAILURE', {
    extra: {
      message: (0, _PubNubMessageSerializer.serialize)(message),
      channel: channel,
      status: status
    }
  });
}), _ActionTypes$PUBLISH_);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/publishHandlers.js
// module id = 499
// module chunks = 0